import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-video\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.62,8.62l4.88,3.25a.4.4,0,0,1,.18.33.42.42,0,0,1-.18.34l-4.88,3.25a.4.4,0,0,1-.62-.33V9a.39.39,0,0,1,.21-.35A.4.4,0,0,1,10.62,8.62ZM4,5.2v14H20V5.2Zm-2-1a1,1,0,0,1,1-1H21a1,1,0,0,1,1,1v16a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol